export enum UserLegalType {
  INDIVIDUAL = 'individual',
  BUSINESS = 'business'
}
